import { Button } from '@fluentui/react-components'
import { ChatBubblesQuestion16Regular, ChatSettings16Regular } from '@fluentui/react-icons'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { createRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { AddChatForm } from '@/ui/Forms/AddChatForm'
import { OverlayDrawerComponent } from '@/ui/OverlayDrawerComponent/OverlayDrawerComponent'

type MessagesChatsExistingChat = RestSchemas['Messages.Chat.ExistingChat']

export function ChatCardButtons({ chat }: { chat: MessagesChatsExistingChat }) {
  const queryClient = useQueryClient()
  const [drawerOpen, setDrawerOpen] = useState<'none' | 'settings' | 'template'>('none')

  const { applicationId } = chat

  const { getChatApiGetChat } = createRestClient()

  const invalidateChats = () => {
    getChatApiGetChat.invalidateQueries({ parameters: { path: { applicationId } } }, queryClient)
  }

  return (
    <>
      <Button size="small" icon={<ChatSettings16Regular />} onClick={() => setDrawerOpen('settings')}>
        Chat settings
      </Button>
      <Button size="small" icon={<ChatBubblesQuestion16Regular />} onClick={() => setDrawerOpen('template')}>
        Chat template
      </Button>

      {/* Edit Settings Drawer */}
      <OverlayDrawerComponent
        open={drawerOpen === 'settings'}
        size="medium"
        setOpen={(open) => setDrawerOpen(open ? 'settings' : 'none')}
        title="Edit Chat Settings"
        content={
          <AddChatForm
            mode="settings"
            applicationId={applicationId}
            selectedChat={chat}
            edit
            onSubmit={() => {
              setDrawerOpen('none')
              invalidateChats()
            }}
          />
        }
      />

      {/* Edit Settings Drawer */}
      <OverlayDrawerComponent
        open={drawerOpen === 'template'}
        size="medium"
        setOpen={(open) => setDrawerOpen(open ? 'template' : 'none')}
        title="Edit Chat Template"
        content={
          <AddChatForm
            mode="template"
            applicationId={applicationId}
            selectedChat={chat}
            edit
            onSubmit={() => {
              setDrawerOpen('none')
              invalidateChats()
            }}
          />
        }
      />
    </>
  )
}
